// authentication/ProtectedRoute.js
import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { FIELD_STAFF_HOME, FIELD_STAFF_ROLE } from './roles';

const ProtectedRoute = ({ children, allowedRoles, allowFieldStaff = false }) => {
  const { isAuthenticated, userRole, loading } = useContext(AuthContext);

  if (loading) {
    return <div>Loading...</div>; // You can replace this with a loading spinner or any UI component
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Field staff never see desktop pages, including routes with no allowedRoles.
  if (userRole === FIELD_STAFF_ROLE && !allowFieldStaff) {
    return <Navigate to={FIELD_STAFF_HOME} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(userRole)) {
    return <Navigate to="/requests" replace />;
  }

  return children;
};

export default ProtectedRoute;
